import React, { JSX, useEffect, useState } from 'react';
import '../style.css';

export const BrasilEffect: React.FC = () => {
  const [hearts, setHearts] = useState<JSX.Element[]>([]);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const heartElements = Array.from({ length: 40 }).map((_, i) => {
      const left = Math.random() * 100;
      const delay = Math.random() * 2;

      return (
        <span
          key={i}
          className="item-nav-theme brasil-effect"
          style={{
            left: `${left}%`,
            animationDelay: `${delay}s`,
            bottom: `-${Math.random() * 20}px`,
          }}
        />
      );
    });

    setHearts(heartElements);

    const timeout = setTimeout(() => {
      setVisible(false);
    }, 5000); // dura 5 segundos

    return () => clearTimeout(timeout);
  }, []);

  if (!visible) return null;

  return <div className="nav-theme-container">{hearts}</div>;
};
